import { useState } from "react";
import { X } from "lucide-react";

const PHOTOS = [
  { src: "/gallery/aquarius-boat-01.jpg",     alt: "Aquarius yacht cruising the Caribbean", span: "row-span-2" },
  { src: "/gallery/aquarius-marlin-01.jpg",   alt: "Blue marlin leaping from the sea" },
  { src: "/gallery/aquarius-catch-01.jpg",    alt: "Yellowfin tuna catch on the deck" },
  { src: "/gallery/aquarius-deck-01.jpg",     alt: "Fighting chair on the aft deck", span: "col-span-2" },
  { src: "/gallery/aquarius-anglers-01.jpg",  alt: "Anglers fighting a fish from the stern" },
  { src: "/gallery/aquarius-helm-01.jpg",     alt: "Captain at the flybridge helm" },
  { src: "/gallery/aquarius-flybridge-01.jpg",alt: "Flybridge deck of Aquarius" },
  { src: "/gallery/aquarius-sunset-01.jpg",   alt: "Aquarius silhouetted at sunset", span: "col-span-2" },
];

export default function Gallery() {
  const [lightbox, setLightbox] = useState(null);

  return (
    <section id="gallery" data-testid="gallery-section" className="aq-section aq-bg-foam-deep">
      <div className="aq-container">
        <span className="aq-overline">Gallery</span>
        <h2 className="aq-h2 text-4xl sm:text-5xl mt-4" style={{ color: "var(--aq-navy)" }}>
          A day on the water.
        </h2>
        <span className="aq-divider" />

        <div className="grid grid-cols-2 md:grid-cols-4 auto-rows-[160px] sm:auto-rows-[200px] gap-3 mt-8">
          {PHOTOS.map((p, i) => (
            <button
              key={p.src}
              data-testid={`gallery-tile-${i}`}
              type="button"
              className={`aq-gallery-tile ${p.span || ""}`}
              onClick={() => setLightbox(p)}
              aria-label={`Open photo: ${p.alt}`}
            >
              <img src={p.src} alt={p.alt} loading="lazy" />
            </button>
          ))}
        </div>
      </div>

      {lightbox && (
        <div className="aq-modal-overlay" onClick={() => setLightbox(null)} data-testid="gallery-lightbox">
          <div
            className="relative"
            style={{ maxWidth: 1100, width: "100%" }}
            onClick={(e) => e.stopPropagation()}
          >
            <button
              type="button"
              data-testid="gallery-lightbox-close"
              aria-label="Close"
              onClick={() => setLightbox(null)}
              className="absolute -top-12 right-0 text-foam hover:text-gold"
              style={{ color: "var(--aq-foam)" }}
            >
              <X size={28} />
            </button>
            <img src={lightbox.src} alt={lightbox.alt} className="w-full h-auto rounded-sm" />
            <p className="mt-3 text-sm text-center" style={{ color: "var(--aq-foam)" }}>
              {lightbox.alt}
            </p>
          </div>
        </div>
      )}
    </section>
  );
}
